






































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListShogTekiyo from '@/components/common/search/ListShogTekiyo.vue';
import { API_SEARCH_SHOGTEKIYO } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlShogTekiyo',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListShogTekiyo,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '諸掛摘要',
    },
    widthCd: {
      type: Number,
      default: 81, //21,
    },
    widthName: {
      type: Number,
      default: 170,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tekiyoShuruiCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_SHOGTEKIYO,
    listShogTekiyoShow: false,
    shogakariTekiyoCd: 0,
    shogakariTekiyoMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { shogakariTekiyoCd, shogakariTekiyoMei } = item;
      this.shogakariTekiyoCd = shogakariTekiyoCd;
      this.shogakariTekiyoMei = shogakariTekiyoMei;
      this.listShogTekiyoShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listShogTekiyoShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.shogakariTekiyoCd = value;
      if (value) {
        this.getShogTekiyoItem();
      } else {
        this.shogakariTekiyoMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk &&
          this.callbackOk({ shogakariTekiyoCd: this.shogakariTekiyoCd });
      }
    },
    getShogTekiyoItem() {
      axios
        .get(API_SEARCH_SHOGTEKIYO, {
          params: {
            shogakariTekiyoCd: this.shogakariTekiyoCd,
            mukoUmuFlg: this.mukoUmuFlg,
            tekiyoShuruiCd:
              this.tekiyoShuruiCd === 0 ? '' : this.tekiyoShuruiCd,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.shogakariTekiyoMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ shogakariTekiyoCd: this.shogakariTekiyoCd });
            return;
          }
          this.errors = clearNoDataError();
          const { shogakariTekiyoMei } = res.data.responseData[0];
          this.shogakariTekiyoMei = shogakariTekiyoMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [shogakariTekiyoCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.shogakariTekiyoCd': {
      handler(newValue) {
        if (+newValue === +this.shogakariTekiyoCd) return;
        this.shogakariTekiyoCd = +newValue;
        if (newValue) {
          this.getShogTekiyoItem();
        } else {
          this.shogakariTekiyoMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.shogakariTekiyoCd) {
      this.shogakariTekiyoCd = +this.$attrs.shogakariTekiyoCd;
    }
  },
});
